export default "__VITE_ASSET__DXT$mTZs__"